/* global pyg*/
import { observable } from 'mobx'
import { action } from 'mobx'
// import mobx from 'mobx'
import _ from 'lodash'
import 'whatwg-fetch'
import moment from 'moment';
import queryString from 'query-string'
import Hdept2DocStore from './Hdept2DocStore'

let Doc2HdeptStore = observable({
  date: moment().toDate(),
  isBusy: false,
  big_table: null,


  hdept: null,
  hdept_ch_name: '',
  hdept_list: [],
  hdept_to_doctor_list_table: {},
  doctor_list: [],
  doctor_to_hdept_list_table: {},
  doctor: '',
  doctor_ch_name: '',

  hdept_quantity: null,

  // team_table: null,
  // teamList: [],
  team: '',
  team_list: [],

  year_selected: '2017',
  month_selected: '03',

  events: [],
  schedule_time: [],

  url_hdept: '',
  url_team: '',
  url_docno: '',
  url_date: '',

  isReady: true,
  message: '',
  show_calendar: false,

  currentSelect: null,
  apiAllData: null
})

_.assign(Doc2HdeptStore, {
  load: action(function () {
    load();
  }),
  setHdept: action(function (val) {
    this.currentSelect = val
    this.isReady = false;
    this.isBusy = true;
    this.message = '';

    // this.doctor = '';

    //修改網址參數
    let parsed = {};
    parsed.hdept = val; //val.HdeptCode;
    parsed.team = '';
    parsed.docno = '';

    parsed.date = this.year_selected + this.month_selected;
    // const stringified = queryString.stringify(parsed);
    // history.pushState(stringified, "page 2", "?" + stringified); //pushState純粹改變網址，html5功能

    // if (val === 'all_doctors') {
    // 	this.hdept = val;
    // 	this.events = [];

    // 	// this.doctor = '';
    //     console.log(this.doctor);
    // 	this.doctor_list = _.uniqBy(_.map(Doc2HdeptStore.big_table, o => ({ EmpNo: o.DocNo, NameCh: o.DocName })), 'EmpNo');
    // 	this.isBusy = false;

    // } else {
    this.isBusy = true;
    this.events = [];
    this.hdept = val;
    this.schedule_time = [];



    this.team = ''; //選了科別，就除空團隊

    //更新此科別對應到的醫生
    // this.doctor_list = this.hdept_to_doctor_list_table[this.hdept]


    // console.log('==============載入此科別中==================')
    // const hdept = this.hdept
    // pyg.api_opd_schdtime({ ptp_hdept_code: this.hdept, doc_no: this.doc_no })//, yyyymm: this.year_selected + this.month_selected })
    // 	.then(function (data) {
    // const data = Doc2HdeptStore.apiAllData ////////////////////////////
    const data = Hdept2DocStore.apiAllData
    // console.log('傳回的資料:', data);
    Doc2HdeptStore.isBusy = true;
    if (_.isEmpty(data)) {
      // throw new EvalError(`科別(${Doc2HdeptStore.hdept})沒有資料。`);
      console.log(`科別(${Doc2HdeptStore.hdept})沒有資料。`)
      Doc2HdeptStore.isBusy = false;
      Doc2HdeptStore.isReady = true;
      Doc2HdeptStore.message = '沒有資料';
    }


    //顯示每一筆時段
    Doc2HdeptStore.schedule_time = _.filter(data, { 'PtpHdeptCode': Doc2HdeptStore.hdept })



    Doc2HdeptStore.isBusy = true;
    // Doc2HdeptStore.doctor = parsed.docno;
    Doc2HdeptStore.events = [];

    let doc_schedule = _.map(_.filter(Doc2HdeptStore.schedule_time, o => { return o.DocNo === Doc2HdeptStore.doctor }), o => {
      return {
        NameCh: o.DocName,
        Noon: o.Noon,
        NoonType: o.NoonType,
        NoonSeg: o.NoonSeg,
        RegDate: o.RegDate,
        Area: o.AreaName
      }
    });
    // console.log('doc_schedule:', doc_schedule);
    
    // 排序
    doc_schedule.sort(function (a, b) { return a.NoonType.localeCompare(b.NoonType, 'zh-Hant') })

    for (let i = 0; i < doc_schedule.length; i++) {
      let my_date = moment(doc_schedule[i].RegDate);

      let title_val = doc_schedule[i].NoonType;
      if (doc_schedule[i].NoonType === '教學下午') {
        title_val = '下午教學';
      }

      let reg_obj = {
        'title': title_val /* + doc_schedule[i].NameCh */,
        'allDay': true,
        'start': my_date,
        'end': my_date,
        'area': doc_schedule[i].Area
      }
      Doc2HdeptStore.events.push(reg_obj);
    }


    // console.log('最後的events:', mobx.toJS(Doc2HdeptStore.events));
    Doc2HdeptStore.isBusy = false;
    Doc2HdeptStore.isReady = true;
    // })
    // .catch(function (error) {
    // 	if (error instanceof EvalError) {
    // 		Doc2HdeptStore.message = '沒有資料';
    // 		Doc2HdeptStore.isBusy = false;
    // 		Doc2HdeptStore.isReady = true;
    // 		console.log(error.message);
    // 	} else {
    // 		Doc2HdeptStore.isReady = true;
    // 		Doc2HdeptStore.isBusy = false;
    // 		alert(error);
    // 		console.log('失敗:', error)
    // 	}
    // })

    //} //else
  }),


  setDoctor: action(function (val) {
    this.currentSelect = val
    this.isReady = false;
    this.isBusy = true;
    this.message = '';
    //修改網址參數
    let parsed = {};
    parsed.hdept = '';
    parsed.team = '';

    parsed.docno = val;
    parsed.date = this.year_selected + this.month_selected;
    // const stringified = queryString.stringify(parsed);
    // history.pushState(stringified, "page 2", "?" + stringified); //pushState純粹改變網址，html5功能

    Doc2HdeptStore.doctor = parsed.docno;
    // console.log('Doc2HdeptStore.big_table: ',Doc2HdeptStore.big_table);
    //若沒有科別，從醫生找到對應科別(hdept_code)
    let hdept_code = '';
    let hdept_result = _.filter(Doc2HdeptStore.big_table, { 'DocNo': parsed.docno });
    if (hdept_result.length === 1) {
      hdept_code = hdept_result[0].PtpHdeptCode;
      this.hdept = hdept_code;

    } else if (hdept_result.length === 0) {
      alert('找不到醫師代碼(' + parsed.docno + ')的科別');
      this.isBusy = false;
      return;
    } else {

      // // 如果先選擇醫師科別預帶 第一個
      // // hdept_code = hdept_result[0].PtpHdeptCode;
      // if (Doc2HdeptStore.hdept === null || Doc2HdeptStore.hdept === '') {
      // 	hdept_code = hdept_result[0].PtpHdeptCode;
      // } else {
      // 	console.log(Doc2HdeptStore.hdept);
      // 	console.log(hdept_code);
      // 	hdept_code = Doc2HdeptStore.hdept;
      // 	console.log('hdept_code變化後...', hdept_code);
      // }

      // if (hdept_result.length > 1) {
      // 	console.log('hdept_result', hdept_result);
      // 	console.log('此醫師有多個科別！');
      // }


      // this.hdept = hdept_code;
      // console.log('this.hdept==>', this.hdept);
      // console.log('hdept_code==>', hdept_code);
      // //this.isBusy = false;

      // 選擇醫師預帶第一筆
      hdept_code = hdept_result[0].PtpHdeptCode;
      // 列出所選科別
      this.hdept = hdept_code
    }


    Doc2HdeptStore.hdept_quantity = hdept_result.length
    // 選擇醫師後，串出此醫師 hdept_list
    let processDocToHdept = []
    processDocToHdept = _.orderBy(_.uniq(hdept_result), [function (o) { return o.PtpHdeptName; }])
    for (let i = 0; i < hdept_result.length; i++) {
      processDocToHdept[i] = {
        HdeptName: processDocToHdept[i].PtpHdeptName,
        HdeptCode: processDocToHdept[i].PtpHdeptCode
      }
    }
    this.hdept_list = processDocToHdept

    // const hdept = this.hdept
    // pyg.api_opd_schdtime({ ptp_hdept_code: hdept_code, doc_no: this.doc_no })//, yyyymm: this.year_selected + this.month_selected })
    // 	.then(function (data) {
    // const data = Doc2HdeptStore.apiAllData ///////////////////
    const data = Hdept2DocStore.apiAllData
    if (_.isEmpty(data)) {
      throw new EvalError(`醫師(${parsed.docno})沒有資料。`);
    }
    Doc2HdeptStore.schedule_time = _.filter(data, { 'PtpHdeptCode': Doc2HdeptStore.hdept });
    // 	return Doc2HdeptStore.schedule_time;
    // })
    // .then(function (schedule_time) {

    Doc2HdeptStore.isBusy = true;
    Doc2HdeptStore.doctor = parsed.docno;
    Doc2HdeptStore.events = [];

    let doc_schedule = _.map(_.filter(Doc2HdeptStore.schedule_time, o => { return o.DocNo === Doc2HdeptStore.doctor }), o => {
      return {
        NameCh: o.DocName,
        Noon: o.Noon,
        NoonType: o.NoonType,
        NoonSeg: o.NoonSeg,
        RegDate: o.RegDate,
        Area: o.AreaName
      }
    });
    // console.log('doc_schedule:', doc_schedule);

    // 排序
    doc_schedule.sort(function (a, b) { return a.NoonType.localeCompare(b.NoonType, 'zh-Hant') })

    for (let i = 0; i < doc_schedule.length; i++) {
      let my_date = moment(doc_schedule[i].RegDate);

      let title_val = doc_schedule[i].NoonType;
      if (doc_schedule[i].NoonType === '教學下午') {
        title_val = '下午教學';
      }

      let reg_obj = {
        'title': title_val /* + doc_schedule[i].NameCh */,
        'allDay': true,
        'start': my_date,
        'end': my_date,
        'area': doc_schedule[i].Area
      }
      Doc2HdeptStore.events.push(reg_obj);
    }

    Doc2HdeptStore.isReady = true;
    Doc2HdeptStore.isBusy = false;
    // })
    // .catch(error => {
    // 	if (error instanceof EvalError) {
    // 		console.log('進入no data領域，', error.message);
    // 		this.message = '沒有資料';
    // 		this.isBusy = false;
    // 		this.isReady = true;
    // 	} else {
    // 		this.isBusy = false;
    // 		alert('錯誤：' + error);
    // 		this.isReady = true;
    // 	}
    // })



  }),
  setTeam: action(function (val) {
    //修改網址參數
    let parsed = {};
    parsed.hdept = '';
    parsed.team = val;
    parsed.docno = '';
    parsed.date = this.year_selected + this.month_selected;
    const stringified = queryString.stringify(parsed);
    history.pushState(stringified, "page 2", "?" + stringified); //pushState純粹改變網址，html5功能


    if (val === 'all_doctors') {
      this.team = val;
      this.events = [];

      this.doctor_list = _.uniqBy(_.map(Doc2HdeptStore.big_table, o => ({ EmpNo: o.EmpNo, NameCh: o.NameCh })), 'EmpNo');

    } else {
      this.hdept = ''; //選了科別，就除空團隊
      this.team = val;
      this.events = [];
      this.isBusy = true;
      this.schedule_time = [];

      pyg.api_opd_teamschdtime({
        team_code: this.team,
        yyyymm: this.year_selected + this.month_selected
      })
        .then(data => {
          console.log('=========================================select teams data', data);
          if (_.isEmpty(data)) {
            throw new Error(`沒有資料。\n\n 呼叫 pyg.api_opd_teamschdtime 後傳回空資料。`)
          }
          //取得此團隊中的醫生列表
          //應該要用api_doc_info_doc_teams來取得喔(3/21)
          this.schedule_time = data;
          this.doctor_list = _.uniqBy(_.map(data, o => { return { EmpNo: o.DocNo, NameCh: o.DocName } }), 'EmpNo');


          //用lodash的寫法
          this.isBusy = true;
          _.forEach(data, (value) => {
            let my_date = moment(value.RegDate);
            let my_obj = {
              'title': value.DocName,
              'allDay': true,
              'start': my_date,
              'end': my_date
            }
            this.events.push(my_obj)
          })

          this.isBusy = false;
        })
        .catch(error => {
          this.isBusy = false;
          console.log('團隊的醫生發生錯誤', error);
        })
    }//else


  })

})

// function checkStatus(response) {
// 	if (response.status >= 200 && response.status < 300) {
// 		return response
// 	} else {
// 		var error = new Error(response.statusText)
// 		error.response = response
// 		throw error
// 	}
// }


function load() {
  Doc2HdeptStore.isBusy = true;
  Doc2HdeptStore.message = '';

  // pyg.api_opd_doc_list()
  //   .then((data) => {

    if (Hdept2DocStore.big_table!==null){

      Doc2HdeptStore.big_table = Hdept2DocStore.big_table

      let dList = []
      dList =Hdept2DocStore.big_table// data// _.orderBy(_.uniq(data), [function (o) { return o.DocNo; }])
      dList = dList.map(x => {
        var array = {}
        array['EmpNo'] = x.DocNo
        array['NameCh'] = x.DocName
        return array
      })
      // console.log(dList.sort(function(a,b){return a.NameCh.localeCompare(b.NameCh)}));
      Doc2HdeptStore.doctor_list = _.uniqWith(dList.sort(function(a,b){return a.NameCh.localeCompare(b.NameCh, 'zh-Hant')}), _.isEqual)

      let hList = []
      hList =Hdept2DocStore.big_table// data
      hList = hList.map(x => {
        var array = {}
        array['HdeptCode'] = x.PtpHdeptCode
        array['HdeptName'] = x.PtpHdeptName
        return array
      })
      Doc2HdeptStore.hdept_list = _.uniqWith(hList, _.isEqual)
      
        Doc2HdeptStore.apiAllData = Hdept2DocStore.apiAllData
      Doc2HdeptStore.isBusy = false;
      Doc2HdeptStore.isReady = true;
    }
  
  
      // })

      // Doc2HdeptStore.apiAllData = Hdept2DocStore.apiAllData
      // Doc2HdeptStore.isBusy = false;
      // Doc2HdeptStore.isReady = true;

  // pyg.api_opd_schdtime()//, yyyymm: this.year_selected + this.month_selected })
  //   .then(function (data) {
  //     Doc2HdeptStore.apiAllData = data
  //     // console.log('傳回的資料:', data);





  //     // // 整理一個專門給 big_table & 科別 & 醫師列表使用
  //     // let bTable = []
  //     // bTable = Doc2HdeptStore.apiAllData
  //     // bTable = bTable.map(x => {
  //     //   var array = {}
  //     //   array['DocName'] = x.DocName
  //     //   array['DocNo'] = x.DocNo
  //     //   array['PtpHdeptCode'] = x.PtpHdeptCode
  //     //   array['PtpHdeptName'] = x.PtpHdeptName
  //     //   return array
  //     // })
  //     // Doc2HdeptStore.big_table = _.uniqWith(bTable, _.isEqual)

  //     // let dList = []
  //     // dList = Doc2HdeptStore.apiAllData// _.orderBy(_.uniq(data), [function (o) { return o.DocNo; }])
  //     // dList = dList.map(x => {
  //     //   var array = {}
  //     //   array['EmpNo'] = x.DocNo
  //     //   array['NameCh'] = x.DocName
  //     //   return array
  //     // })
  //     // Doc2HdeptStore.doctor_list = _.uniqWith(dList, _.isEqual)

  //     // let hList = []
  //     // hList = Doc2HdeptStore.apiAllData
  //     // hList = hList.map(x => {
  //     //   var array = {}
  //     //   array['HdeptCode'] = x.PtpHdeptCode
  //     //   array['HdeptName'] = x.PtpHdeptName
  //     //   return array
  //     // })
  //     // Doc2HdeptStore.hdept_list = _.uniqWith(hList, _.isEqual)





  //     // console.log('最後的events:', mobx.toJS(Doc2HdeptStore.events));
  //     Doc2HdeptStore.isBusy = false;
  //     Doc2HdeptStore.isReady = true;
  //   })
  //   .catch(function (error) {
  //     if (error instanceof EvalError) {
  //       Doc2HdeptStore.message = '沒有資料';
  //       Doc2HdeptStore.isBusy = false;
  //       Doc2HdeptStore.isReady = true;
  //       console.log(error.message);
  //     } else {
  //       Doc2HdeptStore.isReady = true;
  //       Doc2HdeptStore.isBusy = false;
  //       // alert(error);
  //       alert('資料讀取中請稍後')
  //       console.log('失敗:', error)
  //     }
  //   })


  //取得今天日期

  Doc2HdeptStore.year_selected = moment().year();

  let human_readible_month = moment().month() + 1;
  if (human_readible_month < 10) {
    Doc2HdeptStore.month_selected = '0' + human_readible_month;
  } else {
    Doc2HdeptStore.month_selected = human_readible_month;
  }


  // let url = `https://patient.kfsyscc.org/pygg/doc_infodoc_teams.json`
  // pyg.api_doc_info_doc_teams()
  // pyg.api_opd_doc_list()
  //   .then(function (data) {
  //     if (_.isEmpty(data)) {
  //       throw new Error(`後端傳回醫生的資料為空\n\n 呼叫 pyg.api_doc_info_doc_teams 後傳回空資料。`)
  //     }

  //     //簡化資料
  //     Doc2HdeptStore.big_table = data;

  //     //建立科別列表(科名中文+英文)
  //     Doc2HdeptStore.hdept_list = _.uniqBy(_.map(data, o => { return { HdeptCode: o.PtpHdeptCode, HdeptName: o.PtpHdeptName } }), 'HdeptCode');
  //     // console.log('Doc2HdeptStore.hdept_list:', mobx.toJS(Doc2HdeptStore.hdept_list));

  //     //建立所有醫生列表。
  //     Doc2HdeptStore.doctor_list = _.uniqBy(_.map(Doc2HdeptStore.big_table, o => ({ EmpNo: o.DocNo, NameCh: o.DocName })), 'EmpNo');
  //     // console.log('Doc2HdeptStore.doctor_list:', mobx.toJS(Doc2HdeptStore.doctor_list));

  //     Doc2HdeptStore.hdept_to_doctor_list_table = {};
  //     for (let i = 0; i < Doc2HdeptStore.big_table.length; i++) {
  //       //if 現在的科別，已經存在HdeptTable中，就把talbe['新科別'] = 醫師
  //       if (!Doc2HdeptStore.hdept_to_doctor_list_table.hasOwnProperty(Doc2HdeptStore.big_table[i].PtpHdeptCode)) {
  //         Doc2HdeptStore.hdept_to_doctor_list_table[Doc2HdeptStore.big_table[i].PtpHdeptCode] = [];
  //       }

  //       let doctor_obj = {
  //         EmpNo: Doc2HdeptStore.big_table[i].DocNo,
  //         NameCh: Doc2HdeptStore.big_table[i].DocName
  //       }
  //       Doc2HdeptStore.hdept_to_doctor_list_table[Doc2HdeptStore.big_table[i].PtpHdeptCode].push(doctor_obj);
  //     }
  //     // Doc2HdeptStore.hdept_to_doctor_list_table['MED'] = ['王詠', '毛倍領'.....]
  //     // console.log('科別表:', mobx.toJS(Doc2HdeptStore.hdept_to_doctor_list_table));



  //     //讀取網址參數
  //     if (!_.isEmpty(location.search)) {
  //       //如果網址有參數，就進入解析參數，會進去下一層，全部跑完再設isBusy = false;
  //       const parsed = queryString.parse(location.search);

  //       if (parsed.docno) {
  //         Doc2HdeptStore.url_docno = parsed.docno;
  //         Doc2HdeptStore.setDoctor(Doc2HdeptStore.url_docno)
  //       } else if (parsed.hdept) {
  //         Doc2HdeptStore.url_hdept = parsed.hdept;

  //         let result_hdept = _.filter(Doc2HdeptStore.hdept_list, { 'PtpHdeptCode': Doc2HdeptStore.url_hdept });
  //         if (result_hdept.length === 1) {
  //           result_hdept = result_hdept[0]
  //           Doc2HdeptStore.setHdept(result_hdept.PtpHdeptCode);
  //         } else {
  //           console.log('網址參數有部門，但找不到唯一對應的')
  //           location.search = ''
  //           // console.log(Doc2HdeptStore.url_hdept);
  //           // Doc2HdeptStore.url_hdept = ''
  //         }


  //       } else if (parsed.team) {
  //         Doc2HdeptStore.url_team = parsed.team;
  //         Doc2HdeptStore.setTeam(Doc2HdeptStore.url_team);
  //       } else {
  //         Doc2HdeptStore.isBusy = false;
  //       }

  //     } else {
  //       //如果網址沒有參數，直接設isBusy = false;
  //       Doc2HdeptStore.isBusy = false;
  //     }


  //   })
  //   .catch(function (error) {
  //     Doc2HdeptStore.isBusy = false;
  //     alert('使用後端api發生錯誤：pyg.api_opd_doc_list \n\n error:' + error);
  //     console.log('使用後端api發生錯誤：pyg.api_opd_doc_list \n\n error:' + error);
  //     console.log(error);
  //   })



  // // console.log('開始讀取團隊資料...')
  // pyg.api_doc_info_team_list()
  //   .then(d => {
  //     Doc2HdeptStore.team_list = d;
  //   })
  //   .catch(error => {
  //     console.log('讀取團隊資料發生錯誤：', error);
  //   })



}


export default Doc2HdeptStore



// WEBPACK FOOTER //
// ./src/stores/Doc2HdeptStore.js